import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SingleCampaign } from '../../../interface/campaign-management.interface';
import { useAppDispatch } from '../../../redux/hooks';
import { setNotificationMessage } from '../../../redux/slices/NotificationManagementSlice';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
import PageTitle from '../../../shared-components/page-title/PageTitle';
import campaignApi from '../../../utils/api/campaign';

/**
 * View Campaign
 */
function ViewCampaign() {
  const { t } = useTranslation('campaign');
  const dispatch = useAppDispatch();

  const { campaignId } = useParams<{ campaignId: string }>();

  const [campaignDetail, setCampaignDetail] = useState<SingleCampaign[]>([]);
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const column = [
    {
      label: t('accountId'),
      accessorKey: 'accountCustomId' as keyof SingleCampaign,
    },
    {
      label: t('email'),
      accessorKey: 'email' as keyof SingleCampaign,
    },
    {
      label: t('phoneNumber'),
      accessorKey: 'phoneNumber' as keyof SingleCampaign,
    },
    {
      label: t('used'),
      accessorKey: 'used' as keyof SingleCampaign,

      /**
       * Data custom function
       * @param {any} currentRow - The currentRow
       */
      customData: (currentRow: SingleCampaign) => (
        <p className="table-row-each-data">{currentRow.used?.toString()}</p>
      ),
    },
  ];

  useEffect(() => {
    if (campaignId) {
      setPageLoading(true);
      campaignApi
        .fetchSingleCampaign(campaignId)
        .then((response) => {
          const campaignDetailTemporary = response.data.map((data: any) => {
            return {
              ...data,
              id: data._id,
              phoneNumber: `${data.countryCode}${data.phoneNumber}`,
            };
          });

          setCampaignDetail(campaignDetailTemporary);
          setPageLoading(false);
        })
        .catch((error) => {
          dispatch(
            setNotificationMessage({
              type: 'error',
              notificationDetails: {
                statusCode: error?.response?.data?.code || 200,
                message: error?.response?.data?.message || 'Unable to get accounts!',
              },
            }),
          );
          setPageLoading(false);
        });
    }
  }, [campaignId]);

  return (
    <div className="campaign-management-wrap">
      <div className="campaign-management-header">
        <PageTitle title={`${t('viewCampaign')} - ${campaignId}`} />
      </div>
      <div className="table-content">
        <CustomTable
          filterAllow={false}
          header={column}
          data={campaignDetail}
          loading={pageLoading}
          serialNo
          sizeChangeButtonRequired
          disablePagination
        />
      </div>
    </div>
  );
}

export default ViewCampaign;
